module.exports = __webpack_public_path__ + "static/industryCards-ee3616f0e9ccdd316e40b0e077cf26df.png";